import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { MaskedLine, Reveal } from "@/components/Reveal";
import { waLink } from "@/lib/whatsapp";

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const CtaBand = () => {
  const { t } = useLang();
  const c = t.home.cta;

  return (
    <section data-testid="cta-band" className="bg-espresso text-offwhite">
      <div className="wrap py-20 sm:py-28 lg:py-32">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow text-terracotta">{t.nav.cta}</p>
            </Reveal>
            <MaskedLine mode="view">
              <h2 className="mt-4 max-w-2xl font-display text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                {c.title}
              </h2>
            </MaskedLine>
            <Reveal delay={0.1}>
              <p className="mt-6 max-w-lg text-sm font-light leading-relaxed text-offwhite/70 sm:text-base">
                {c.sub}
              </p>
            </Reveal>
          </div>

          <div className="w-full max-w-md lg:col-span-5 lg:justify-self-end">
            <Reveal delay={0.15}>
              <a
                href={waLink(t.nav.waMessage)}
                target="_blank"
                rel="noreferrer"
                data-testid="cta-band-whatsapp-button"
                className="inline-flex w-full items-center justify-center gap-3 rounded-full bg-teak px-8 py-4 text-sm font-medium text-offwhite transition-all duration-300 hover:-translate-y-0.5 hover:bg-terracotta sm:w-auto"
              >
                <MessageCircle className="h-5 w-5" />
                {c.button}
              </a>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="eyebrow mt-9 text-offwhite/50">{c.chipsLabel}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.chips.map((chip) => (
                  <a
                    key={chip}
                    href={waLink(`${t.nav.waMessage} — ${chip}`)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`cta-chip-${slug(chip)}`}
                    className="rounded-full border border-offwhite/25 px-4 py-2 text-xs text-offwhite/80 transition-colors duration-300 hover:border-teak hover:bg-teak/10 hover:text-offwhite sm:text-sm"
                  >
                    {chip}
                  </a>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
